export function formAction() {
    if (location.search){
        const tgtTextBox = document.getElementById('contact_building');
        const urlParam = location.search.substring(1);

        const param = urlParam.split('=');

        tgtTextBox.value = decodeURIComponent(param[1]);
    }


    const confirmBtn = document.getElementsByClassName('wpcf7c-btn-confirm')[0];
    const formBody = document.getElementsByClassName('wpcf7')[0];

    if (confirmBtn){
        confirmBtn.addEventListener('click',function () {
            let formTop =   window.pageYOffset + formBody.getBoundingClientRect().top - 120;

            window.scrollTo({
                top:formTop,
                behavior:"smooth"
            });
        })
    }
}